export const FAVOURITE_SPACES_STORE_NAME = "favoriteSpaces";
